// Task durations are stored as decimal hours (e.g. 2.5). These helpers let the
// UI capture and display them as hours + minutes.

export function toHM(decimalHours) {
  if (decimalHours === null || decimalHours === undefined || decimalHours === '') {
    return { h: '', m: '' };
  }
  const total = Math.round(Number(decimalHours) * 60);
  if (isNaN(total)) return { h: '', m: '' };
  return { h: String(Math.floor(total / 60)), m: String(total % 60) };
}

export function fromHM(h, m) {
  const hh = parseInt(h, 10) || 0;
  const mm = parseInt(m, 10) || 0;
  if (!hh && !mm) return null;
  return Math.round((hh + mm / 60) * 100) / 100;
}

export function fmtDuration(decimalHours) {
  if (decimalHours === null || decimalHours === undefined) return '—';
  const total = Math.round(Number(decimalHours) * 60);
  if (isNaN(total)) return '—';
  const h = Math.floor(total / 60);
  const m = total % 60;
  if (h && m) return `${h}h ${m}m`;
  if (h) return `${h}h`;
  return `${m}m`;
}
